//@ts-nocheck

import React, {useRef} from "react";
import { motion } from 'framer-motion';
import Layout from '../components/Layout/Layout'

import ActionBtn from '../components/Button/ActionBtn';

import { Col, Container, Row } from 'react-bootstrap'





const PrivacyPolicy = () => {
  const handlePdfDownload = (pdfUrl: string, fileName: string) => {
    fetch(pdfUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
  };
  // 1. Create a reference for the form
  const formRef = useRef();

  // 2. Create a handler for form submission
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_t80qe2q',   // Replace with your Service ID
        'template_tn7w75g', // Replace with your Template ID
        formRef.current,    // Reference to the form
        '37maWWNmcPSwXXr8W'  // Replace with your Public Key
      )
      .then(
        (result) => {
          console.log('SUCCESS!', result.text);
          // This alert will appear on successful email send
          alert('Your message has been sent successfully to our legal team. We will get back to you shortly.');
          // Optionally clear the form
          e.target.reset();
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert('Oops! Something went wrong. Please try again later.');
        }
      );
  };

  return (
    <Layout title="Privacy Policy" description="Legal Documents Page">
     <section className="pt-16 md:pt-24 lg:pt-32 pb-0 relative overflow-hidden">
        <img
          src="/images/Container.svg"
          className="absolute w-full h-full object-cover left-1/2 -translate-x-1/2 top-0 pointer-events-none"
          alt=""
        />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-[1]">
          <motion.h2 
            className="font-bold text-4xl sm:text-5xl md:text-6xl lg:text-6xl mb-4 sm:mb-6 text-black leading-tight"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Privacy Policy
          </motion.h2>
         
          <motion.p 
            className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-8 sm:mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            At FuteurAI, your trust is our priority. Our comprehensive legal framework safeguards your data, ensures compliance, and upholds fairness in every interaction.
          </motion.p>
        </div>
      </section>
    
      <section className='py-2'>
        <div className="xs:px-2">
          <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] bg-Mneutral100 rounded-[24px] sm:rounded-[56px]">
            <Container>
              <div className="grid grid-rows-1 gap-y-6">
                <div className="w-full p-3 md:p-6 lg:p-8 bg-white rounded-[32px]">
                  <Row className='justify-between gap-y-3'>
                    <div className="lg:px-[2rem]">
                      <h2 className='font-semibold text-3xl md:text-4xl mb-8 text-black'>FuteurAI Privacy Policy</h2>
                      <p className='text-lg mb-6 text-gray-700'>Last Updated: March 13, 2025</p>
                      
                      <div className="mb-10">
                        <h3 className='font-medium text-2xl md:text-3xl mb-4 text-black'>1. Introduction</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            At FuteurAI, we are committed to helping small and medium-sized businesses improve their financial standing and secure funding by providing access to business intelligence and credit insights across our website, mobile applications, and other services (collectively, "Services"). We believe in financial transparency and responsible data handling. This privacy policy outlines how we collect, store, process, and share data, particularly in relation to business credit reports and lending pre-qualification, while ensuring compliance with applicable regulations.
                          </p>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>2. Definitions</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            The terms "we," "us," and "our" refer to FuteurAI Inc. and its affiliates. The terms "you," "yours," and "users" refer to any individual or business entity interacting with FuteurAI's platform, website, mobile applications, or services.
                          </p>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>3. Data Controllers</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <div className='mb-4'>
                            <p className='text-lg leading-relaxed text-gray-800'>
                              FuteurAI Inc.<br />
                              1 Rockefeller Plaza, Floor 6<br />
                              New York, NY 10020<br />
                              Email: <span className="text-blue-600 font-medium">support@futeur.ai</span><br />
                              Phone: <span className="text-blue-600 font-medium">+1 (877) - 827 - 2095</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>4. Data We Collect and Store</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            We collect and store various types of data to provide business intelligence and financial services:
                          </p>
                          <ol className="list-decimal pl-6 space-y-3">
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Business Credit Data</span> (obtained from credit bureaus such as Experian, Equifax, and Dun & Bradstreet) for underwriting, risk evaluation, and lending pre-qualification.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Personal Identification Information:</span> Name, email, phone number, business details.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Transaction Data:</span> Payment history, financial records, funding eligibility.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">AI-Driven Insights:</span> Automated decisioning to match businesses with appropriate financial products.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Technical Data:</span> IP addresses, browser details, geographic location, device information, mobile app usage data.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Third-Party Data:</span> Received from vendors, financial institutions, and regulatory bodies.
                            </li>
                          </ol>
                          <p className='text-lg leading-relaxed mt-4 text-gray-800'>
                            By using FuteurAI Services, you consent to the collection and processing of this data.
                          </p>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>5. How We Use Your Information</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <ol className="list-decimal pl-6 space-y-3">
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Lending Pre-Qualification & Underwriting:</span> Business credit reports are used to assess financial eligibility for funding opportunities.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Credit Profile Access:</span> We provide users with visibility into their credit data for financial improvement.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Risk Evaluation:</span> Data helps ensure lending partners match businesses with suitable products.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Compliance & Fraud Prevention:</span> Strict adherence to laws governing business credit data usage.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Education & Guidance:</span> Businesses receive personalized insights to enhance credit readiness.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Service Improvement:</span> Analyzing how users interact with our Services to enhance user experience and functionality.
                            </li>
                          </ol>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>6. Bulk Data Processing & Compliance</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <ul className="list-disc pl-6 space-y-3">
                            <li className='text-lg leading-relaxed text-gray-800'>
                              We purchase and process business credit reports in bulk for underwriting and financial assessment purposes.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              All data is strictly used for evaluation and qualification, never for resale.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              Customers receive detailed guidance on how their credit data is assessed.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              We maintain compliance with all regulatory bodies overseeing credit reporting and financial underwriting.
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>7. AI-Driven Decisioning & Risk Mitigation</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <ul className="list-disc pl-6 space-y-3">
                            <li className='text-lg leading-relaxed text-gray-800'>
                              Automated models help evaluate credit risk and lending opportunities while ensuring fairness and non-discriminatory decision-making.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              We use explainable AI techniques to allow transparency in financial pre-qualification.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              Businesses can challenge AI-driven decisions and request human review where necessary.
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>8. Data Sharing and Third-Party Partners</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            FuteurAI partners with multiple financial institutions and service providers, including but not limited to:
                          </p>
                          <ul className="list-disc pl-6 space-y-3">
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Credit Bureaus</span> (Experian, Equifax, Dun & Bradstreet): To retrieve and analyze credit history.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Lenders & Financial Institutions:</span> When referring businesses for funding opportunities.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Data Storage & Security Vendors:</span> Such as cloud providers for secure data handling.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Analytics and Tracking Services:</span> To help us understand how users interact with our Services and improve user experience.
                            </li>
                          </ul>
                          <p className='text-lg leading-relaxed mt-4 text-gray-800'>
                            We ensure that third parties comply with data protection regulations and do not misuse shared data. When using our mobile applications, we may share certain device information with mobile platform providers as necessary for the functioning of the application.
                          </p>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>9. Data Retention & Deletion</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <ul className="list-disc pl-6 space-y-3">
                            <li className='text-lg leading-relaxed text-gray-800'>
                              Business credit data is retained for up to four (4) months post-account deletion unless required by law.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              Users can request account deletion and removal of associated data, except where required for fraud prevention or compliance.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              Data related to underwriting decisions is stored securely and only used for pre-agreed financial assessment purposes.
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>10. Security & Encryption Measures</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            We implement industry-leading security protocols, including:
                          </p>
                          <ul className="list-disc pl-6 space-y-3">
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Encryption in Transit & At Rest:</span> Protecting sensitive credit and financial data.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Strict Access Controls:</span> Limiting data access to authorized personnel only.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Fraud Detection Systems:</span> AI-driven analysis to detect anomalies in credit applications.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Compliance Monitoring:</span> Regular audits to maintain adherence to credit bureau guidelines.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Secure Mobile Application:</span> Our mobile applications implement additional security measures specific to mobile platforms.
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>11. Your Rights & Consumer Protections</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            You have the right to:
                          </p>
                          <ol className="list-decimal pl-6 space-y-3">
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Access & Review Credit Data:</span> Request a copy of your business credit report used in lending decisions.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Correct Inaccuracies:</span> Dispute and update incorrect data.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Opt-Out of Data Sharing:</span> Restrict how your information is shared with financial institutions.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Request Deletion:</span> Have your personal and business data removed where legally applicable.
                            </li>
                          </ol>
                          <p className='text-lg leading-relaxed mt-4 text-gray-800'>
                            Requests can be submitted to <span className="text-blue-600 font-medium">support@futeur.ai</span>.
                          </p>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>12. Mobile Application Privacy</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            When using our mobile applications, we may collect additional data specific to mobile usage:
                          </p>
                          <ul className="list-disc pl-6 space-y-3">
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Device Information:</span> Type of mobile device, operating system version, unique device identifiers.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Mobile Analytics:</span> How you use our mobile application, including crash data and performance metrics.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Local Storage:</span> Some data may be stored locally on your device to improve application performance.
                            </li>
                          </ul>
                          <p className='text-lg leading-relaxed mt-4 text-gray-800'>
                            Our mobile applications do not access or collect data from other applications on your device. You can control certain data collection through your device settings. Uninstalling our application will remove locally stored data, but will not affect data stored on our servers.
                          </p>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>13. Compliance with U.S. State Privacy Laws</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            This privacy policy complies with major U.S. state laws, including:
                          </p>
                          <ul className="list-disc pl-6 space-y-3">
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">California Consumer Privacy Act (CCPA) & CPRA:</span> Providing transparency on data collection and opt-out options.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Colorado Privacy Act (CPA):</span> Ensuring compliance with financial data protection standards.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Virginia Consumer Data Protection Act (VCDPA):</span> Guaranteeing fair access to credit data.
                            </li>
                            <li className='text-lg leading-relaxed text-gray-800'>
                              <span className="font-medium">Connecticut Data Privacy Act (CTDPA) & Nevada Chapter 603A (N603):</span> Ensuring non-discriminatory use of credit profiles.
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>14. Children's Privacy</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            Our Services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us at <span className="text-blue-600 font-medium">support@futeur.ai</span> and we will take steps to delete such information.
                          </p>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>15. International Data Transfers</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            FuteurAI primarily operates in the United States. If you access our Services from outside the United States, your information may be transferred to, stored, and processed in the United States or other countries where our servers are located. By using our Services, you consent to any transfer of information outside of your country. We implement appropriate safeguards when transferring data across borders.
                          </p>
                        </div>
                      </div>

                      <div className="mb-10">
                        <h3 className='font-medium text-2xl mb-4 text-black'>16. Policy Updates</h3>
                        <div className="mb-6 pl-4 border-l-4 border-gray-200">
                          <p className='text-lg leading-relaxed mb-4 text-gray-800'>
                            We regularly update our Privacy Policy to reflect regulatory changes and enhancements in our data protection framework. Users will be notified of major changes, and continued use of our Services constitutes agreement with the latest policy.
                          </p>
                        </div>
                      </div>
                      
                      <div className="mt-12 mb-4 flex justify-start">
                        <ActionBtn text="Back to Home" link="/" className="px-8" />
                      </div>
                    </div>
                  </Row>
                </div>
              </div>
            </Container>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPolicy;
